import {cloneDeep} from 'lodash';

const initialState = {};

function getInitialState() {
  return cloneDeep(initialState);
}

const actions = {
    SERVICES_ACTION_UPDATE_GH_IMAGES: () => ({...getInitialState()}),

    SERVICES_ACTION_STB_ACTIONS: () => ({...getInitialState()}),

    SERVICES_ACTION_UPDATE_STB_ACTIONS: (state, {data}) => ({
        ...state,
        data,
    }),
    SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_GET: (state, {responseGet}) => ({
        ...state,
        responseGet,
    }),
    SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_POST: (state, {responsePost}) => ({
        ...state,
        responsePost,
    }),
    SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_PUT: (state, {responsePut}) => ({
        ...state,
        responsePut,
    }),
    SERVICES_ACTION_UPDATE_STB_ACTIONS_FULFILLED_DELETE: (state, {responseDelete}) => ({
        ...state,
        responseDelete,
    }),
    SERVICES_ACTION_UPDATE_STB_ACTIONS_REJECTED: (state, {error}) => ({
        ...state,
        error,
    }),

    SERVICES_ACTION_PROPERTIES_ACTIONS: () => ({...getInitialState()}),

    SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS: (state, {data}) => ({
        ...state,
        data,
    }),
    SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_FULFILLED_GET: (state, {responsePropertiesGet}) => ({
        ...state,
        responsePropertiesGet,
    }),
    SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_FULFILLED_PUT: (state, {responsePropertiesPut}) => ({
        ...state,
        responsePropertiesPut,
    }),
    SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_FULFILLED_POST: (state, {responsePropertiesPost}) => ({
        ...state,
        responsePropertiesPost,
    }),
    SERVICES_ACTION_UPDATE_PROPERTIES_ACTIONS_REJECTED: (state, {error}) => ({
        ...state,
        error,
    }),
};

const servicesActionData = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default servicesActionData;
